import { useId, type ReactNode } from 'react';
import styles from './UnpublishedChangeGroup.module.css';

interface UnpublishedChangeGroupProps {
  title: string;
  children: ReactNode;
}

export const UnpublishedChangeGroup = ({ title, children }: UnpublishedChangeGroupProps) => {
  const headingId = useId();

  return (
    <section className={styles.unpublishedChangeGroup} aria-labelledby={headingId}>
      <h3 id={headingId}>{title}</h3>
      <ul>{children}</ul>
    </section>
  );
};
